<template>
  <div
    :class="{
      'mc-data__blank--list': placementType == 'list',
      'mc-data__blank--grid': placementType == 'grid',
    }"
  >
    <div v-if="placementType === 'grid'">
      <b-row align-v="center">
        <b-col md="4">
          <figure :class="`mc-data__blank-image ${size}`">
            <img :src="illustrationPath" :title="title" :alt="title" />
          </figure>
        </b-col>
        <b-col md="8">
          <h3 class="mc-data__blank-title">{{ title }}</h3>
          <p class="text-muted mc-data__blank-text" v-if="desc">{{ desc }}</p>
          <div v-if="hasButton" class="mc-data__empty-state-grid">
            <McButton
              variant="primary"
              :icon="buttonIco"
              :text="computedButtonText"
              :disabled="isDisabled"
              @click="$emit('buttonPrimaryAction')"
            />
            <McButton
              v-if="buttonTextSecondary"
              variant="secondary"
              :icon="buttonIconSecondary"
              :text="buttonTextSecondary"
              :disabled="isDisabled"
              @click="$emit('buttonSecondaryAction')"
            />
          </div>
          <div class="mc-data__empty-state-grid">
            <slot name="button-value-help"></slot>
          </div>
        </b-col>
      </b-row>
    </div>
    <div v-else-if="placementType === 'list'">
      <figure :class="`mc-data__blank-image ${size}`">
        <img :src="illustrationPath" :title="title" :alt="title" :width="customImgSize" />
      </figure>
      <h3 class="mc-data__blank-title">{{ title }}</h3>
      <p class="text-muted mc-data__blank-text" v-if="desc">{{ desc }}</p>
      <div v-if="hasButton" class="mc-data__blank-button">
        <McButton
          variant="primary"
          :icon="buttonIco"
          :text="computedButtonText"
          :disabled="isDisabled"
          @click="$emit('buttonPrimaryAction')"
        />
        <McButton
          v-if="buttonTextSecondary"
          variant="secondary"
          :icon="buttonIconSecondary"
          :text="buttonTextSecondary"
          :disabled="isDisabled"
          @click="$emit('buttonSecondaryAction')"
        />
      </div>
      <div class="mc-data__blank-button">
        <slot name="button-value-help"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import McButton from '@/components/McButton'

export default {
  components: {
    McButton,
  },
  props: {
    title: {
      type: String,
      required: false,
    },
    desc: {
      type: String,
      required: false,
    },
    hasButton: {
      type: Boolean,
      default: true,
      required: false,
    },
    buttonText: {
      type: String,
      required: false,
    },
    buttonTextSecondary: {
      type: String,
      required: false,
    },
    buttonIco: {
      type: String,
      default: 'icon-outline_plus',
      required: false,
    },
    buttonIconSecondary: {
      type: String,
      default: '',
      required: false,
    },
    size: {
      type: String,
      default: 'md',
      required: false,
    },
    placementType: {
      type: String,
      default: 'list',
      required: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    customFigure: {
      type: String,
      default: 'no-data',
      required: false,
    },
    customImgSize: {
      type: String,
      default: '',
      required: false,
    },
  },
  computed: {
    ...mapGetters({
      isWhitelabel: 'identity/isWhitelabel',
      isMetrack: 'identity/isMetrack',
    }),

    illustrationPath() {
      if (this.isWhitelabel() || this.isMetrack()) {
        return require(`@/assets/images/illustration/whitelabel/no-data.svg`)
      }
      return require(`@/assets/images/illustration/saas/${this.customFigure}.svg`)
    },
    computedButtonText() {
      return this.buttonText ? this.buttonText : this.$t('global.create')
    },
  },
}
</script>
